import * as actions from '../actions/actions'

const initialState = {
  message: '',
  error: ''
}

export default function password(state = initialState, action) {
  switch (action.type) {
    case actions.CHANGE_PASSWORD_SUCCESS:
      return changePasswordSuccess(state, action)
    case actions.CHANGE_PASSWORD_FAILURE:
      return changePasswordFailure(state, action)
    case actions.RECOVER_PASSWORD_SUCCESS:
      return recoverPasswordSuccess(state, action)
    case actions.RECOVER_PASSWORD_FAILURE:
      return recoverPasswordFailure(state, action)
    default:
      return state
  }
}

const changePasswordSuccess = (state, action) => {
  return {
    ...state,
    message: action.value,
    error: ""
  }
}

const changePasswordFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const recoverPasswordSuccess = (state, action) => {
  return {
    ...state,
    message: action.value
  }
}

const recoverPasswordFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}
